import { createStore } from 'vuex';
import axios from 'axios';
import Api from '@/apis/api.js';
import { playAudio } from '../utils/tool';
import { modifyProject } from '../common/commons';
import { request } from '../common/request';
// 数据无法通过lodash merge 合并 合并之后不再具有响应式
function setState(state, stateKey = '', val = {}) {
  for (let key in val) {
    if (Object.keys(val[key]).length >= 1 && typeof val[key] === 'object') {
      for (let subKey in val[key]) {
        if (Object.keys(val[key][subKey]).length >= 1 && typeof val[key][subKey] === 'object') {
          for (let subKey2 in val[key][subKey]) {
            if (
              Object.keys(val[key][subKey][subKey2]).length >= 1 &&
              typeof val[key][subKey][subKey2] === 'object'
            ) {
              for (let subKey3 in val[key][subKey][subKey2]) {
                state[stateKey][key][subKey][subKey2][subKey3] = val[key][subKey][subKey2][subKey3];
              }
            } else {
              state[stateKey][key][subKey][subKey2] = val[key][subKey][subKey2];
            }
          }
        } else {
          state[stateKey][key][subKey] = val[key][subKey];
        }
      }
    } else {
      state[stateKey][key] = val[key];
    }
  }
}
export default createStore({
  state: {
    isAudioPlaying: false, // 是否在播放语音
    dataContainer: {
      // 临时存储数据容器
      data1: [1, 2, 3],
      data2: [],
      data3: [],
    },
    currentSceneId: '', // 新增状态用于存储当前场景 ID
    mapevent: '',
    isMeutConfig: false,
    // 路况列表
    // roadCoodsList:[],
    // 当前选中的路段经纬度
    currentRoadCood: {},
    // 开启 关闭 自动循环按钮
    showCarousel: false,
    // 手机端还是pc 是否是手机端（小于等于768px视为手机端）
    isMobile: false,
    // 保存原本的背景
    backgroundDefault: null,
    // 视频列表
    monitorList: [],
    // 点位列表
    pointList: [],
    // 热力图列表
    heatMapList: null,
    // 热力图经纬度
    heatMapLngLat: [],
    // 当前选中的热力图
    currentheatmap: {},
    // 当前选中的视频
    currentMonitor: {},
    // 当前选中的点位
    currentPoint: {},
    // 是否显示全局的loading
    isShowGlobalLoading: false,
    //判断程序是否在iframe中
    isInIframe: false,
    // 是否在编辑模式 与预览和发布状态进行区分
    isEditMode: false,
    // 是否正在拖动图表组件
    isEdingChartsPosSize: false,
    //登录状态
    login_status: false,
    // 判断当前选择页面id
    sceneId: '',
    //用户信息
    userInfo: {},
    styleIcon1: {},
    styleIcon2: {},
    // 客户端视口大小信息
    ClientViewSize: {
      width: 0,
      height: 0,
    },
    // 编辑页面的左右菜单栏打开状态
    IndexInfo: {
      isOpenRightMenu: false,
      isOpenLeftMenu: true,
    },
    // 下拉框数据值
    stateParamsYear: '2023',
    stateParamsMonth: '01',
    // 判断当前图表是否已连接api
    JudgeLocalApi: {},
    isMouseEnteredScreen: false,
    // 保存当前项目的row_id
    ProjectID: '',
    // 保存当前项目的pid
    ProjectPid: '',
    // 图标3数据
    RightIconData: {},
    // 当前项目信息 这个信息会序列化为字符串 保存到数据库
    ProjectInfo: {
      // 是否已经发布
      isPublished: false,
      // 项目发布配置
      PublishConfig: {
        // 是否使用发布密码
        isUsePassWord: '0',
        // 发布密码
        PassWord: '',
        // 发布链接
        PublishUrl: '',
      },
      // 是否隐藏所有图表 隐藏状态信息
      isHideAllCharts: false,
      // 是否隐藏当前场景图表 隐藏
      isCurrentScene: false,
      Name: '大数据分析系统',
      // 屏幕尺寸
      ScreenSize: {
        width: 1920,
        height: 1080,
      },
      // 屏幕缩放比例
      ScreenRatio: {
        w_Ratio: 72,
        h_Ratio: 72,
        old_w_Ratio: 72,
        old_h_Ratio: 72,
      },
      // 当前场景数据
      CurrentScene: null,
      /* 项目背景 */
      Background: {},
      /* 当前项目风格 */
      Style: {},
      /* 场景列表 */
      SceneryList: [
        {
          id: 'scene_default',
          IconPath: './img/styles/menusIcons/menuIcon1.png',
          OverViewImg: './img/scene/scene.png',
          SceneName: '默认场景',
          Charts: [],
        },
      ],
    },
    /* 图表组件右键菜单控制 */
    ContextMenu: {
      isOpen: false,
      position: {
        left: 0,
        top: 0,
      },
    },
    // 组合组件 右键菜单控制
    ComBined: {
      isOpen: false,
      position: {
        left: 0,
        top: 0,
      },
    },
    // 背景管理列表
    BackgroundsList: [],
    // 风格管理列表
    StylesList: [],
    // 图表组件管理列表
    ChartsList: [],
    /* 当前配置信息 右侧属性列表 */
    CurrentConfigration: {},
    ThumbNailData: {
      /* 当前视觉区域大小 */
      ViewZoneSize: {
        width: 0,
        height: 0,
      },
      /* screen当前实际大小 */
      ScreenCurrentShowSize: {
        width: 0,
        height: 0,
      },
      /* SWO 真实大小 */
      ScreenWrapperOuterFullSize: {
        width: 0,
        height: 0,
      },
      /* 视觉范围的当前位置 */
      ViewZonePos: {
        left: 0,
        top: 0,
      },
    },
    socket: null,
    digitalhumandisplay: false,
  },
  mutations: {
    setCurrentSceneId(state, id) {
      console.log('vuexsetCurrentSceneId', id);

      state.currentSceneId = id;
    },
    setSocket(state, payload) {
      state.socket = payload;
    },
    setIsAudioPlaying(state, payload) {
      state.isAudioPlaying = payload;
    },
    setDataNum(state, payload) {
      // 需要传入对象 {name:数据容器名称,index:数组索引,value:值}
      state.dataContainer[payload.name][payload.index] = payload.value;
    },
    setCurrentRoadCood(state, payload) {
      state.currentRoadCood = payload;
    },
    // setRoadCoodsList(state,payload){
    //   state.roadCoodsList = payload
    // },
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    setBackgroundDefault(state, payload) {
      state.backgroundDefault = payload;
    },
    // 设置点位列表
    setPointList(state, payload) {
      state.pointList = payload;
    },
    // 设置热力图列表
    setHeatMapList(state, payload) {
      state.heatMapList = payload;
    },
    // 设置热力图列表
    set_Mapevent(state, payload) {
      console.log(payload, 'set_Mapevent');
      state.mapevent = payload;
    },
    // 数字人显示状态
    // set_DigitalHumanShow(state, payload) {
    //   console.log(payload, 'set_DigitalHumanShow');
    //   state.digitalhumandisplay = payload;
    // },
    // 设置热力图经纬度数据
    setHeatMapLngLat(state, payload) {
      state.heatMapLngLat = payload;
    },
    // 设置当前热力图
    setCurrentHeatMap(state, payload) {
      state.currentheatmap = payload;
    },
    // 设置当前视频
    setCurrentMonitor(state, payload) {
      state.currentMonitor = payload;
    },
    // 下拉框 年
    stateParamsY(state, payload) {
      state.stateParamsYear = payload;
    },
    // 月
    stateParamsM(state, payload) {
      state.stateParamsMonth = payload;
    },
    // 图标 3 数据值
    // setRightIconData(state, payload) {
    //   // console.log(RightIconData,'33333333333');
    //   state.RightIconData = payload;

    // },
    //设置登录状态
    setLoginStatus(state, payload) {
      state.login_status = payload;
    },
    //设置用户信息
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    // 设置右边配置项为默认背景
    set_defaultCurrentConfigToBackground(state) {
      if (state?.ProjectInfo.Background) {
        state.CurrentConfigration = state.ProjectInfo.Background;
      }
    },
    // 清除当前场景中的所有图标组件
    clearAllChartsFromCurrentScene(state) {
      if (state?.ProjectInfo?.CurrentScene?.Charts) {
        state.ProjectInfo.CurrentScene.Charts = [];
      }
    },
    // 设置全局loading状态
    setLoading(state, val) {
      state.isShowGlobalLoading = val;
    },
    // 设置全局loading状态
    set_leftMeutConfig(state, val) {
      console.log(val, 'set_leftMeutConfig');
      state.isMeutConfig = val;
    },
    setisInIframe(state, val) {
      state.isInIframe = val;
    },
    // 实在是否在是编辑模式
    set_editMode(state, val) {
      state.isEditMode = val;
    },
    // 设置图表组件的显示状态 最小化 隐藏 正常显示
    set_chartsShowStatus(state, val) {
      // 解构数据 id 为修改图表组件目标id status 显示状态 isAll 是否更改全部组件状态
      let { id = 'none', status = 'norm', isAll = false } = val;
      let TargetChart = null;
      state.ProjectInfo.SceneryList.forEach(scene => {
        if (isAll) {
          scene.Charts.forEach(chart => {
            chart.propertyData.showStatus.value = status;
          });
          state.ProjectInfo.isHideAllCharts = status === 'hide';
        } else {
          TargetChart = scene.Charts.find(chart => chart.id === id);
          if (TargetChart) {
            TargetChart.propertyData.showStatus.value = status;
          }
          state.ProjectInfo.isHideAllCharts = false;
        }
      });
    },
    // 设置 当前场景 图表组件的显示状态 隐藏 正常显示
    set_curreSceneShowStatus(state, val) {
      // 解构数据 id 为修改图表组件目标id status 显示状态 isCurre 是否更改当前组件状态
      let { id = 'none', status = 'norm', isCurre = false } = val;
      console.log(id, status, isCurre, 'sdsdfsdfsdffjaf');
      let TargetChart = null;
      state.ProjectInfo.CurrentScene.Charts.forEach(scene => {
        console.log(scene, 'scene sdsdfsdfsdffjaf');
        if (isCurre) {
          // scene.Charts.forEach(chart => {
          scene.propertyData.showStatus.value = status;
          // });
          state.ProjectInfo.isCurrentScene = status === 'hide';
        } else {
          TargetChart = scene.find(chart => chart.id === id);
          console.log(TargetChart, 'TargetChart sdsdfsdfsdffjaf');
          if (TargetChart) {
            TargetChart.propertyData.showStatus.value = status;
          }
          state.ProjectInfo.isCurrentScene = false;
        }
      });
    },
    // 设置是否正在更改组件位置 拖动组件
    set_isEdingChartsPosSize(state, val) {
      state.isEdingChartsPosSize = val;
    },
    // 修改右键菜单信息
    set_ContextMenu(state, val) {
      console.log(state, 'ContextMenu', val);
      setState(state, 'ContextMenu', val);
    },
    // 组合 修改右键菜单信息
    set_ComBined(state, val) {
      console.log(state, 'ComBined', val);
      setState(state, 'ComBined', val);
    },
    // 处理缩放比例变更
    set_ScreenRatio(state, val) {
      console.log('set_ScreenRatio ok');
      for (let key in val) {
        state.ProjectInfo.ScreenRatio[key] = val[key];
      }
      // 处理缩放比例变更 图表大组件的缩放 ScreenRatio缩放值
      let c_wRation = state.ProjectInfo.ScreenRatio.w_Ratio / state.ProjectInfo.ScreenRatio.old_w_Ratio;
      let c_hRation = state.ProjectInfo.ScreenRatio.h_Ratio / state.ProjectInfo.ScreenRatio.old_h_Ratio;
      // console.log(state.ProjectInfo, 'c_wRation c_hRation');
      state.ProjectInfo.SceneryList.forEach(item => {
        item.Charts.forEach(chart => {
          chart.style.width = chart.style.width * c_wRation;
          chart.style.height = chart.style.height * c_hRation;
          chart.style.top = chart.style.top * c_hRation;
          chart.style.left = chart.style.left * c_wRation;
        });
      });
      state.ProjectInfo.ScreenRatio.old_h_Ratio = val.h_Ratio;
      state.ProjectInfo.ScreenRatio.old_w_Ratio = val.w_Ratio;
    },
    // 修改鼠标是否在screen内的状态
    set_isMouseEnteredScreen(state, val) {
      // console.log(state, val, '鼠标是否在screen内的状态');
      state.isMouseEnteredScreen = val;
    },
    // 删除图表组件
    del_Charts(state, id) {
      let delCharts_index = state.ProjectInfo.CurrentScene.Charts.findIndex(item => item.id === id);
      state.ProjectInfo.CurrentScene.Charts.splice(delCharts_index, 1);
      state.CurrentConfigration = {
        id: 'no component id',
        componentTitle: '未选中组件',
      };
    },
    // 组合 删除 组件
    del_Combo_Box(state, id) {
      state.ProjectInfo.CurrentScene.Charts.forEach(item => {
        if (!item.Charts) return;
        let del_chart = item.Charts.findIndex(deltBox => {
          return deltBox.id === id;
        });
        if (del_chart != -1) {
          item.Charts.splice(del_chart, 1);
        }
      });
    },
    // 添加 图表 组件
    add_Charts(state, val) {
      if (state.ProjectInfo.CurrentScene && state.isMouseEnteredScreen) {
        state.ProjectInfo.CurrentScene.Charts.push(val.Config);
        state.CurrentConfigration = val.Config;
        console.log('图表添加成功！1');
      } else {
        console.log('图表添加失败！1');
      }
    },
    // 添加 组合 图标组件
    back_add_charts(state, val) {
      if (state.ProjectInfo.CurrentScene && state.isMouseEnteredScreen) {
        state.ProjectInfo.CurrentScene.Charts.find(item => {
          return item.id === val.id;
        }).Charts.push(val.Config);
        state.CurrentConfigration = val.Config;
        console.log('图表添加成功！2');
      } else {
        console.log('图表添加失败！2');
      }
    },
    // 更新当前配置属性列表的信息
    update_CurrentConfigration(state, val) {
      setState(state, 'CurrentConfigration', val);
    },
    // 清空当前配置属性列表的信息
    del_CurrentConfigration(state) {
      console.log(state, 'state  state');
      state.CurrentConfigration = {
        id: 'no component id',
        componentTitle: '未选中组件',
      };
    },
    // 更新组件的PropertyData属性 不能直接赋值 因为直接赋值会导致变量内存地址更改 数据响应失效
    update_PropertyData(state, val) {
      let { key, value } = val;
      console.log(key, value, 'test test ');
      if (Object.keys(value).length >= 1 && typeof value === 'object' && !Array.isArray(value)) {
        for (let valueKey in value) {
          if (
            Object.keys(value[valueKey]).length >= 1 &&
            typeof value[valueKey] === 'object' &&
            !Array.isArray(value[valueKey])
          ) {
            for (let valueKey2 in value[valueKey]) {
              if (
                Object.keys(value[valueKey][valueKey2]).length >= 1 &&
                typeof value[valueKey][valueKey2] === 'object' &&
                !Array.isArray(value[valueKey][valueKey2])
              ) {
                for (let valueKey3 in value[valueKey][valueKey2]) {
                  state.CurrentConfigration.propertyData[key].value[valueKey][valueKey2][valueKey3] =
                    value[valueKey][valueKey2][valueKey3];
                }
              } else {
                state.CurrentConfigration.propertyData[key].value[valueKey][valueKey2] =
                  value[valueKey][valueKey2];
                // if(key === 'ChartsData'){
                //   console.log("@@@@")
                //   value['staticData']['source'].forEach(item=>{

                //     if(item.s === 'glyph'){
                //       console.log(item);
                //       item.y = JSON.parse(JSON.stringify(item.y))
                //     }
                //   })
                // }
                // console.log('*****',value);
              }
            }
          } else {
            if (state.CurrentConfigration?.propertyData?.[key])
              state.CurrentConfigration.propertyData[key].value[valueKey] = value[valueKey];
          }
        }
      } else {
        if (state.CurrentConfigration?.propertyData?.[key])
          state.CurrentConfigration.propertyData[key].value = value;
      }
    },

    // 设置当前配置信息 右侧配置栏
    set_CurrentConfigration(state, val) {
      console.log(state, val, '000000000');
      let cid = '';
      if (Object.keys(val).length !== 2) {
        state.CurrentConfigration = val;
      } else {
        cid = val.cid; // 父id
        state.CurrentConfigration = val.val;
      }
      // 编辑页面的右菜单栏打开状态
      state.IndexInfo.isOpenRightMenu = true;
      // 判断是否为图表组件 更新图表组件显示层级
      if (state.CurrentConfigration.componentName.endsWith('Charts')) {
        if (cid) {
          console.log(cid, '处理子图表');
          let id = state.CurrentConfigration.id;
          let parentTarget = state.ProjectInfo.CurrentScene.Charts.find(item => item.id === cid);
          let target = parentTarget.Charts.find(item => item.id === id);
          let parentIndex = state.ProjectInfo.CurrentScene.Charts.findIndex(item => item.id === cid);
          let index = parentTarget.Charts.findIndex(item => item.id === id);

          parentTarget.Charts.splice(index, 1);
          parentTarget.Charts.push(target);

          state.ProjectInfo.CurrentScene.Charts.splice(parentIndex, 1);
          state.ProjectInfo.CurrentScene.Charts.push(parentTarget);
        } else {
          console.log('正常图表');
          let id = state.CurrentConfigration.id;
          let target = state.ProjectInfo.CurrentScene.Charts.find(item => item.id === id);
          let index = state.ProjectInfo.CurrentScene.Charts.findIndex(item => item.id === id);
          state.ProjectInfo.CurrentScene.Charts.splice(index, 1);
          state.ProjectInfo.CurrentScene.Charts.push(target);
        }
      }
    },
    // 设置当前背景数据
    set_ProjectBackground(state, val) {
      state.ProjectInfo.Background = val;
    },
    // 设置当前背景数据
    set_styleIcon1(state, val) {
      state.styleIcon1 = val;
    },
    // 设置当前背景数据
    set_styleIcon2(state, val) {
      state.styleIcon2 = val;
    },
    // 设置当前背景数据
    set_ProjectBackgroundData(state, val) {
      state.ProjectInfo.Background = val;
    },
    // 设置当前风格数据
    set_ProjectStyle(state, val) {
      console.log(state, val, '设置当前风格数据');
      state.ProjectInfo.Style = val;
    },
    // 设置当前风格的PropertyData数据
    set_ProjectStylePropertyData(state, val) {
      let { key, value } = val;
      console.log(val, '设置当前风格的PropertyData数据');
      if (Object.keys(value).length >= 1 && typeof value === 'object' && !Array.isArray(value)) {
        for (let valueKey in value) {
          if (
            Object.keys(value[valueKey]).length >= 1 &&
            typeof value[valueKey] === 'object' &&
            !Array.isArray(value[valueKey])
          ) {
            for (let valueKey2 in value[valueKey]) {
              if (
                Object.keys(value[valueKey][valueKey2]).length >= 1 &&
                typeof value[valueKey][valueKey2] === 'object' &&
                !Array.isArray(value[valueKey][valueKey2])
              ) {
                for (let valueKey3 in value[valueKey][valueKey2]) {
                  state.ProjectInfo.Style.propertyData[key].value[valueKey][valueKey2][valueKey3] =
                    value[valueKey][valueKey2][valueKey3];
                }
              } else {
                state.ProjectInfo.Style.propertyData[key].value[valueKey][valueKey2] =
                  value[valueKey][valueKey2];
              }
            }
          } else {
            state.ProjectInfo.Style.propertyData[key].value[valueKey] = value[valueKey];
          }
        }
      } else {
        state.ProjectInfo.Style.propertyData[key].value = value;
      }
    },
    // 设置背景列表
    set_BackgroundsList(state, val) {
      state.BackgroundsList = val;
    },
    // 设置风格列表
    set_StylesList(state, val) {
      state.StylesList = val;
    },
    // 设置可拖动组件列表
    set_ChartsList(state, val) {
      state.ChartsList = val;
    },
    // 添加场景
    add_SceneToSceneryList(state, val) {
      console.log(state, val, '添加场景 数据');
      state.ProjectInfo.SceneryList.push(val);
    },
    // 修改场景信息
    mod_SceneOfSceneryListById(state, val) {
      console.log(state, val, '修改场景信息');
      let { id, modConfig } = val;
      console.log(val, 'val 修改场景信息');
      let target = state.ProjectInfo.SceneryList.find(scene => scene.id === id);
      if (target) {
        console.log(target, 'target 修改场景信息');
        target.IconPath = modConfig.sceneIcon;
        target.SceneName = modConfig.sceneName;
        target.SceneDesc = modConfig.sceneDesc;
        target.isChangeBk = modConfig.isChangeBk;
        target.Background = modConfig.Background;
        target.jumpTo = modConfig.jumpTo;
        target.linkUrl = modConfig.linkUrl;
        target.isChangelink = modConfig.isChangelink;
      }
    },
    // 删除场景
    del_SceneFromSceneryList(state, id) {
      state.ProjectInfo.SceneryList.splice(
        state.ProjectInfo.SceneryList.findIndex(item => item.id === id),
        1,
      );
    },
    // 初始化当前场景 默认取第一个
    init_CurrentScene(state) {
      state.ProjectInfo.CurrentScene = state.ProjectInfo.SceneryList[0];
    },
    // 设置当前场景 多个场景切换
    set_CurrentScene(state, id) {
      // console.log(state, id, '设置当前场景 多个场景切换');
      state.sceneId = id;
      // 查找当前场景
      let scene = state.ProjectInfo.SceneryList.find(item => item.id === id);
      if (scene) {
        // 场景信息赋值
        state.ProjectInfo.CurrentScene = scene;
      }
    },
    // 设置客户端当前的屏幕尺寸信息
    set_ClientViewSize(state, val) {
      // console.log(state, val, 'ClientViewSize');
      setState(state, 'ClientViewSize', val);
    },
    // 设置当前编辑页面index页的左右菜单栏打开状态
    set_IndexInfo(state, val) {
      setState(state, 'IndexInfo', val);
    },

    // 设置底部缩略图信息
    set_ThumbNailData(state, val) {
      setState(state, 'ThumbNailData', val);
    },
    // 设置项目的row_id  保存修改需要项目row_id发送请求
    set_ProjectID(state, val) {
      state.ProjectID = val;
    },
    // 设置项目的pid 生成访问链接需要
    set_ProjectPid(state, val) {
      state.ProjectPid = val;
    },
    // 初始化项目，将之前的数据清空
    reset_ProjectEmpty(state) {
      state.ProjectInfo = {
        isPublished: false,
        PublishConfig: {
          isUsePassWord: '0',
          PassWord: '',
          PublishUrl: '',
        },
        isHideAllCharts: false,
        // 是否隐藏当前场景图表 隐藏
        isCurrentScene: false,
        Name: '大数据分析系统',
        // 屏幕尺寸
        ScreenSize: {
          width: 1920,
          height: 1080,
        },
        ScreenRatio: {
          w_Ratio: 72,
          h_Ratio: 72,
          old_w_Ratio: 72,
          old_h_Ratio: 72,
        },
        CurrentScene: null,
        /* 项目背景 */
        Background: {},
        /* 当前项目风格 */
        Style: {},
        /* 场景列表 */
        SceneryList: [
          {
            id: 'scene_default',
            IconPath: './img/styles/menusIcons/menuIcon1.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '默认场景',
            Charts: [],
          },
        ],
      };
    },
    // 设置项目名字
    set_ProjectName(state, val) {
      state.ProjectInfo.Name = val;
    },
    // 修改当前项目信息 局部覆盖
    set_ProjectInfo(state, val) {
      setState(state, 'ProjectInfo', val);
    },
    // 整体修改项目信息 全部覆盖
    set_allProjectInfo(state, val) {
      state.ProjectInfo = val;
    },
  },

  // 异步方法
  actions: {
    updateCurrentSceneId({ commit }, id) {
      commit('setCurrentSceneId', id);
    },
    // 获取项目数据通过pid
    getProjectByPid({ commit }, sid) {
      // sid.pid 项目pid  sid.cid 当前场景id
      return new Promise((resolve, reject) => {
        // 构造请求参数
        let params = {
          method: 'post',
          url: Api.getProjects + '&pid=' + sid.pid + '&current=' + sid.cid,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        };
        // 发起请求
        request(params)
          .then(response => {
            console.log(response, 'response response');
            let ProjectData = null;
            // 检查响应是否成功
            if (response && response.data && response.errCode === '0') {
              // 获取列表中的第一个项目数据
              if (response?.data?.list?.[0]) {
                ProjectData = response?.data?.list?.[0];
                // 检查项目是否已发布，未发布则拒绝访问
                if (ProjectData.is_publish !== '1') {
                  reject('访问未发布！');
                  return;
                }

                // 处理配置数据字符串，去除首尾多余的引号
                let projectInfoStr = ProjectData.config_data;
                projectInfoStr = projectInfoStr.replace(/^"/, '');
                projectInfoStr = projectInfoStr.replace(/"$/, '');

                let projectInfo;
                // 先按原格式解析JSON
                try {
                  projectInfo = JSON.parse(projectInfoStr);
                  // 解析成功，直接执行后续逻辑
                } catch (error) {
                  // 解析失败，尝试处理转义字符后再次解析
                  let processedString = projectInfoStr;
                  // 去除开头可能存在的引号和转义符
                  processedString = processedString.replace(/^\s*\\\\?"\s*/, '');
                  // 去除结尾可能存在的引号和转义符
                  processedString = processedString.replace(/\s*\\+\s*$/, '');
                  processedString = processedString
                    // 先将 \\ 简化为 \（两个斜杠保留一个）
                    .replace(/\\\\/g, '\\')
                    // 再去除孤立的单个 \（不参与 \n 或 \\ 的斜杠）
                    // 规则：匹配 \ 但后面不跟 n（排除 \n），且前面不是 \（排除已处理的单个 \）
                    .replace(/(?<!\\)\\(?!n|r)/g, '');
                  try {
                    projectInfo = JSON.parse(processedString);
                    console.log(projectInfo, '外格式处理后解析成功');
                  } catch (secondError) {
                    console.error('外格式处理后仍解析失败:', secondError);
                    projectInfo = null; // 彻底失败的降级处理
                  }
                }

                // let projectInfo = JSON.parse(projectInfoStr);
                // 更新ProjectInfo数据到Vuex state
                commit('set_allProjectInfo', projectInfo);
                // 从URL中获取current参数（场景ID）
                const url = window.location.href;
                const currentParam = url.match(/[?&]current=([^&#]*)/)?.[1];
                // 更新当前场景id  判断是否有值并处理
                if (currentParam) {
                  // URL中有current参数，使用该参数设置当前场景
                  console.log('有参数', currentParam);
                  commit('set_CurrentScene', currentParam);
                } else {
                  // URL中没有current参数，使用第一个场景作为默认场景
                  console.log('没有参数', currentParam);
                  commit('set_CurrentScene', projectInfo.SceneryList[0].id);
                }

                // 保存项目id 用于提交修改项目数据到数据库
                commit('set_ProjectID', ProjectData.row_id);
                commit('set_ProjectPid', ProjectData.pid);
                resolve(ProjectData);
              } else {
                // 列表中没有数据
                reject('访问数据不存在！');
              }
            } else {
              // 响应错误码不为0
              reject('请求错误！');
            }
          })
          .catch(err => {
            // 请求异常
            reject(err);
          });
      });
    },
    // 获取项目数据通过 row_id
    getProject({ commit }) {
      return new Promise(function(resolve, reject) {
        let params = {
          method: 'post',
          url: Api.getProjects,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        };
        request(params)
          .then(response => {
            console.log(response, '111111111111');

            let project_row_id = window.localStorage.getItem('project_row_id');
            let targetProjet = response.data.list.find(
              item => item.row_id.toString() === project_row_id.toString(),
            );

            if (targetProjet.config_data == 'null' || targetProjet.config_data == null) {
              commit('set_ProjectID', targetProjet.row_id);
              commit('set_ProjectPid', targetProjet.pid);
              commit('set_defaultCurrentConfigToBackground');
            } else {
              let rowDataString = targetProjet.config_data;
              rowDataString = rowDataString.replace(/^"/, '');
              rowDataString = rowDataString.replace(/"$/, '');

              let projectInfo;
              // 先按原格式解析
              try {
                projectInfo = JSON.parse(rowDataString);
                // 解析成功，直接执行后续逻辑
              } catch (error) {
                let processedString = rowDataString;
                processedString = processedString.replace(/^\s*\\\\?"\s*/, '');
                processedString = processedString.replace(/\s*\\+\s*$/, '');
                processedString = processedString
                  // 先将 \\ 简化为 \（两个斜杠保留一个）
                  .replace(/\\\\/g, '\\')
                  // 再去除孤立的单个 \（不参与 \n 或 \\ 的斜杠）
                  // 规则：匹配 \ 但后面不跟 n（排除 \n），且前面不是 \（排除已处理的单个 \）
                  .replace(/(?<!\\)\\(?!n|r)/g, '');
                try {
                  projectInfo = JSON.parse(processedString);
                  console.log(projectInfo, '外格式处理后解析成功');
                } catch (secondError) {
                  console.error('外格式处理后仍解析失败:', secondError);
                  projectInfo = null; // 彻底失败的降级处理
                }
              }
              // let projectInfo = JSON.parse(rowDataString);

              if (targetProjet.is_publish === '1') {
                projectInfo.isPublished = true;
              }
              // 更新ProjectInfo数据
              commit('set_allProjectInfo', projectInfo);
              // 更新当前场景id
              commit('set_CurrentScene', projectInfo.SceneryList[0].id);
              // 保存项目id 用于提交修改项目数据到数据库
              commit('set_ProjectID', targetProjet.row_id);
              commit('set_ProjectPid', targetProjet.pid);
              commit('set_defaultCurrentConfigToBackground');
              resolve(response);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 保存项目
    saveProject({ state }) {
      return new Promise((resolve, reject) => {
        let queryId = '';
        if (state.ProjectID) {
          queryId = state.ProjectID;
        } else {
          queryId = 1;
        }

        let sendStr = JSON.stringify(state.ProjectInfo);
        // axios
        //   .post(Api.modifyProject, {
        //     data: {
        //       project_name: state.ProjectInfo.Name,
        //       config_data: sendStr,
        //       dataId: queryId,
        //     },
        //     headers: {
        //       'content-type': 'application/json',
        //     },
        //   })
        console.log(state.ProjectInfo.Name, sendStr, queryId, '4545454545454545');
        modifyProject({
          data: {
            project_name: state.ProjectInfo.Name,
            config_data: sendStr,
            dataId: queryId,
          },
        })
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
  },
  modules: {},
});
